import React from 'react';
import { Users, Eye, MousePointerClick, TrendingUp, TrendingDown } from 'lucide-react';

function ChangeIndicator({ change }) {
  if (change === null || change === undefined) return null;
  if (change === 0) return <span className="text-xs text-gray-400">0%</span>;

  const isPositive = change > 0;
  return (
    <span className={`inline-flex items-center gap-0.5 text-xs font-medium ${isPositive ? 'text-emerald-600' : 'text-red-500'}`}>
      {isPositive ? <TrendingUp className="h-3 w-3" /> : <TrendingDown className="h-3 w-3" />}
      {Math.abs(change)}%
    </span>
  );
}

function StatCard({ icon: Icon, label, value, change, iconColor }) {
  return (
    <div className="bg-white rounded-xl border border-gray-100 p-5 shadow-sm hover:shadow-md transition-shadow">
      <div className="flex items-center justify-between mb-3">
        <span className="text-xs font-medium text-gray-500 uppercase tracking-wider">{label}</span>
        <Icon className={`h-4 w-4 ${iconColor || 'text-gray-400'}`} />
      </div>
      <div className="flex items-end gap-2">
        <span className="text-2xl font-bold text-gray-900">{typeof value === 'number' ? value.toLocaleString('nb-NO') : value}</span>
        <ChangeIndicator change={change} />
      </div>
    </div>
  );
}

export default function StatCards({ stats, currentVisitors }) {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      <StatCard
        icon={Users}
        label="Besøkende"
        value={stats?.visitors?.value || 0}
        change={stats?.visitors?.change}
        iconColor="text-emerald-500"
      />
      <StatCard
        icon={Eye}
        label="Sidevisninger"
        value={stats?.pageviews?.value || 0}
        change={stats?.pageviews?.change}
        iconColor="text-blue-500"
      />
      <StatCard
        icon={MousePointerClick}
        label="Visninger/besøk"
        value={stats?.viewsPerVisit?.value || '0'}
        change={null}
        iconColor="text-purple-500"
      />
      <div className="bg-white rounded-xl border border-gray-100 p-5 shadow-sm hover:shadow-md transition-shadow">
        <div className="flex items-center justify-between mb-3">
          <span className="text-xs font-medium text-gray-500 uppercase tracking-wider">Akkurat nå</span>
          <span className="relative flex h-3 w-3">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" />
            <span className="relative inline-flex rounded-full h-3 w-3 bg-emerald-500" />
          </span>
        </div>
        <div className="flex items-end gap-2">
          <span className="text-2xl font-bold text-gray-900">{currentVisitors}</span>
          <span className="text-xs text-gray-500 mb-0.5">besøkende</span>
        </div>
      </div>
    </div>
  );
}
